"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useContentUploadedSLI = void 0;
var _useCommonPageActionsApi = require("../../client/react/useCommonPageActionsApi");
var _SLIErrorPrefix = require("../../constants/SLIErrorPrefix");
/**
 * Custom hook to manage content uploaded SLI
 *
 * @returns {Object} An object containing the following properties:
 * - trackContentUploadedSLI: Function start tracking content upload SLI.
 */
var useContentUploadedSLI = exports.useContentUploadedSLI = function useContentUploadedSLI() {
  var _useCommonPageActions = (0, _useCommonPageActionsApi.useCommonPageActionsApi)(),
    contentUploaded = _useCommonPageActions.contentUploaded;

  /**
   * Tracks content upload SLI
   *
   * * @param {Object} props - The properties for tracking content upload SLI.
   * @param {string} props.title - The title of uploaded file
   * @param {string} props.fileType - The fileType of uploaded file
   * @param {string} props.extension - The extension of uploaded file
   * @param {string} props.isDragAndDrop - The flag to check drag and drop
   * @param {string} props.isMultiFileUpload - The flag to check file is multipart upload
   * @param {string} props.error - The error if any while uploading file
   * @param {string} props.externalVideoId - The external video Id of video file uploaded by UVS
   * @param {number} props.fileSize - The size of the uploaded file in bytes.
   */
  var trackContentUploadedSLI = function trackContentUploadedSLI(props) {
    var title = props.title,
      fileType = props.fileType,
      extension = props.extension,
      isDragAndDrop = props.isDragAndDrop,
      isMultiFileUpload = props.isMultiFileUpload,
      error = props.error,
      externalVideoId = props.externalVideoId,
      fileSize = props.fileSize;
    contentUploaded({
      title: title,
      fileType: fileType,
      extension: extension,
      isDragAndDrop: isDragAndDrop,
      isMultiFileUpload: isMultiFileUpload,
      externalVideoId: externalVideoId,
      fileSizeInBytes: fileSize,
      error: error ? "".concat(_SLIErrorPrefix.CONTENT_UPLOAD_SLI_ERROR_PREFIX).concat(error) : null
    });
  };
  return {
    trackContentUploadedSLI: trackContentUploadedSLI
  };
};